import { pickUsingStringAsIndex } from "@lib/utils";
import { pxToRem } from "@utils";
import styled from "styled-components";
import { StyledAvatarProps } from "./types";
import { avatarSizeToFontSize, avatarSizeToPx } from "./utils";

export const StyledAvatar = styled.div<StyledAvatarProps>`
  background: ${({ $imageURL, $color, $initials, $email, theme }) =>
    $imageURL
      ? `scroll center/contain no-repeat url('${$imageURL}')`
      : $color
      ? $color
      : $initials && $email
      ? pickUsingStringAsIndex($email, theme.avatar.colors)
      : theme.avatar.unknown};
  border: ${({ $border, theme }) => $border || `2px solid ${theme.avatar.border}`};
  border-radius: 9999px;
  color: ${({ theme }) => theme.text.color.body};
  display: grid;
  font-size: ${({ $size, $isGroupAvatar }) => pxToRem(avatarSizeToFontSize($size, $isGroupAvatar))};
  font-weight: 600;
  height: ${({ $size, $borderCorrection, $isGroupAvatar }) =>
    pxToRem(avatarSizeToPx($size, $isGroupAvatar) - ($borderCorrection || 0))};
  line-height: 1;
  place-items: center;
  position: relative;
  width: ${({ $size, $borderCorrection, $isGroupAvatar }) =>
    pxToRem(avatarSizeToPx($size, $isGroupAvatar) - ($borderCorrection || 0))};
  ${({ $disabled, theme, $size, $isGroupAvatar }) =>
    $disabled &&
    `&::before {
    content: '';
    background: ${theme.background.white};
    top: -2px;
    left: -2px;
    position: absolute;
    border-radius: 9999px;
    opacity: 0.7;
    height: calc(${pxToRem(avatarSizeToPx($size, $isGroupAvatar))} + .1rem);
    width: ${pxToRem(avatarSizeToPx($size, $isGroupAvatar))};
  }`}
`;
